import React from 'react';
import { Field, RadioGroup } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import PreparationWetSection from './PreparationWetSection';
import PreparationDrySection from './PreparationDrySection';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';

let PreparationSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const preparationMethod = useSelector(createWorksheetSelector!('Preparation.PreparationMethod'));

  return (
    <>
      <ListFieldSection name="Preparation">
        <Field
          input={<RadioGroup />}
          label="Preparation Method"
          name="Preparation.PreparationMethod"
          options={['Wet', 'Dry'].map((e) => ({ label: e, value: e }))}
        />
      </ListFieldSection>
      {preparationMethod === 'Wet' ? <PreparationWetSection /> : <PreparationDrySection />}
    </>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
